// extracted by mini-css-extract-plugin
module.exports = {"section":"mapTooltip_section__1zw2E","sectionTitle":"mapTooltip_sectionTitle__y_XZ7"};